if (window.piwikConfig) {
    var _paq = _paq || [];

    angular.forEach(piwikConfig.parameters, function (parameter) {
        _paq.push(parameter);
    });

    var url = impactX.isDefined(piwikConfig, 'url');
    var trackerUrl = url;
    if (!url) {
        console.log("missing url in piwik config");
    } else {
        trackerUrl = url.endsWith('/') ? url : url + '/';
    }


    var siteId = impactX.isDefined(piwikConfig, 'siteId');
    if (!siteId) {
        console.log("missing site id in piwik config");
    }

    _paq.push(['setTrackerUrl', trackerUrl + 'matomo.php']);
    _paq.push(['setSiteId', siteId]);

    var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
    g.type = 'text/javascript';
    g.async = true;
    g.defer = true;
    g.src = trackerUrl + 'matomo.js';
    s.parentNode.insertBefore(g, s);
}
